import Icon from 'veui/components/Icon'
import { IconQuestionCircleSolid } from 'dls-icons-vue'

Icon.register('question-circle-solid', IconQuestionCircleSolid)
